export const theme = {
  token: {
    colorPrimary: "#f5ad1d",
    colorInfo: "#f5ad1d",
  },
  components: {
    Layout: {
      headerBg: "#ffffff",
    },
    Button: {
      colorPrimary: "#02374d",
      colorPrimaryHover: "#024c66",
      colorPrimaryActive: "#024c66",
    },
    Descriptions: {
      itemPaddingBottom: "8px",
    },
  },
};
